// @note(juan): false positive

import { TypeConfigurations, TypeConfigurationsFields } from 'types/contentful';
import ContentService from 'utils/contentful/contentfulService';

 
export enum ContentfulConfigId {
  LIVE_PHONE_CALLS_CONFIG = 'LIVE_PHONE_CALLS_CONFIG',
  THERAPIST_SUPPORT_PHONE_NUMBER = 'THERAPIST_SUPPORT_PHONE_NUMBER',
}

export class ConfigurationNotFoundError extends Error {}

export const getContentfulConfig = (configId: ContentfulConfigId): Promise<TypeConfigurations> => {
  return ContentService.clients.expressable
    .getEntries<TypeConfigurationsFields>({
      'fields.configurationId[match]': configId,
      content_type: 'configurations',
    })
    .then(r => {
      if (r.items.length === 0) {
        throw new ConfigurationNotFoundError();
      }
      return r.items[0];
    })
    .catch(e => {
      throw new ConfigurationNotFoundError(e);
    });
};
